import centroid from '@turf/centroid';
import { multiPolygon, polygon } from '@turf/helpers';
import { gsap, Linear } from 'gsap/all';
import { camera, controls, scene } from '../../location-world.js';
import { gConf } from './config.js';
import { countriesWithHQ, Globe } from './globe';
import { setFilter } from './interaction';

export const getCenterCoordinates = (feature) => {
	const { type, coordinates } = feature.geometry;
	let polygons;

	if (type === 'Polygon') {
		polygons = polygon(coordinates);
	} else {
		polygons = multiPolygon(coordinates);
	}

	return centroid(polygons);
};

let camZeroDistance;
export const goToCoords = (country = 'DE') => {
	const centerCoords = countriesWithHQ.mids[country].geometry.coordinates;
	// For whatever reason, the geojson coordinates lat and lng are swapped.
	// So the first value is the longitude and the second is the latitude.
	// converts (lat, lng) to world position
	const coords = Globe.getCoords(centerCoords[1], centerCoords[0], 0);
	/* ---------------------------------------------------- */

	// Helper object to see the correct focus point of the camera.
	// refSphere.position.set(coords.x, coords.y, coords.z);
	camZeroDistance = camera.position.distanceTo(scene.position);

	const camEndPos = {
		x: (camZeroDistance * coords.x) / gConf.globe.radius,
		y: (camZeroDistance * coords.y) / gConf.globe.radius,
		z: (camZeroDistance * coords.z) / gConf.globe.radius,
	};

	gsap.to(camera.position, {
		duration: 1,
		x: camEndPos.x,
		y: camEndPos.y,
		z: camEndPos.z,
		ease: Linear.easeNone,
		onUpdate: function () {
			controls.update();
		},
	});

	setFilter(country);
};
